import { IDictionaryMarketSegment } from '@/creditflowresearch/domain/vo/IDictionary';
import Segment from './Segment';
import CorpSegment from './entities/CorpSegment';
import FigSegment from './entities/FigSegment';
import SsaSegment from './entities/SsaSegment';
import { MarketSegment } from '@/creditflowresearch/domain/Market/types/MarketSegment';

type SegmentConstructor = new (data: IDictionaryMarketSegment) => Segment;

class SegmentFactory {
  private static readonly entityClassMap = new Map<string, SegmentConstructor>([
    [CorpSegment.SEGMENT_ID, CorpSegment],
    [FigSegment.SEGMENT_ID, FigSegment],
    [SsaSegment.SEGMENT_ID, SsaSegment],
  ]);

  static createFromData(data: IDictionaryMarketSegment): Segment | null {
    const EntityClass = SegmentFactory.entityClassMap.get(data.id);

    if (!EntityClass) {
      return null;
    }

    const segmentData: IDictionaryMarketSegment = {
      id: data.id,
      name: data.name as MarketSegment,
    };

    return new EntityClass(segmentData);
  }
}

export default SegmentFactory;
